export const CFM_RASPBERRY = '#ff3b30';
export const CFM_ORANGE = '#ff8c00';
export const CFM_BANANA = '#ffc341';
export const CFM_KIWI = '#86ad20';
export const CFM_BLUEBERRY = '#0576b9';
export const CFM_BLACKBERRY = '#2e2d4c';
export const CFM_MILK = '#fff';
export const CFM_VOLCANO = '#3c4248';
export const CFM_STONE = '#788590';
export const CFM_METAL = '#ced4d9';
export const CFM_FOG = '#dce3eb';
export const CFM_CLOUD = '#f6f7f9';
export const CFM_MILKSHAKE1 = '#ffc341';
export const CFM_MILKSHAKE2 = '#f54752';
export const CFM_DOLPHIN = '#e1edff';
export const CFM_ALUMINIUM = '#e9eef3';
export const CFM_SNOW = '#f0f3f5';
